import { render } from "./zaixiantongji.vue?vue&type=template&id=c7a2b7de&scoped=true"
import script from "./zaixiantongji.vue?vue&type=script&lang=js"
export * from "./zaixiantongji.vue?vue&type=script&lang=js"

import "./zaixiantongji.vue?vue&type=style&index=0&id=c7a2b7de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a2b7de"]])

export default __exports__